import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-container" }

import AboutMe from '@/components/AboutMe.vue'
import Experience from '@/components/Experience.vue'
import Education from '@/components/Education.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AboutMe),
    _createVNode(Experience),
    _createVNode(Education)
  ]))
}
}

})